import React, { ComponentPropsWithoutRef, FC } from 'react';
import cx from 'classnames';

import styles from './styles.module.css';

type StripesProps = ComponentPropsWithoutRef<'svg'>;

const Stripes: FC<StripesProps> = ({
  className,
  xmlns = 'http://www.w3.org/2000/svg',
  viewBox = '0 0 100 100',
  ...props
}) => (
  <svg
    className={cx(styles.stripes, className)}
    xmlns={xmlns}
    viewBox={viewBox}
    {...props}
  >
    <defs>
      <pattern id="dashboard-stripes-pattern" width="16" height="16" patternTransform="rotate(60)" patternUnits="userSpaceOnUse">
        <line x2="0" y2="16" stroke="black" strokeWidth="4" />
      </pattern>
      <mask id="dashboard-stripes">
        <rect width="9999em" height="9999em" fill="white" />
        <rect width="9999em" height="9999em" fill="url(#dashboard-stripes-pattern)" />
      </mask>
    </defs>
  </svg>
);

export default Stripes;
